/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FareBasisValidationData,
    FareBasisValidationDataFromJSON,
    FareBasisValidationDataFromJSONTyped,
    FareBasisValidationDataToJSON,
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface GlobalFilterRuleFormValidationData
 */
export interface GlobalFilterRuleFormValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterRuleFormValidationData
     */
    description?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterRuleFormValidationData
     */
    effectiveDates?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterRuleFormValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterRuleFormValidationData
     */
    distributionChannels?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterRuleFormValidationData
     */
    agenciesAndGroups?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterRuleFormValidationData
     */
    routes?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterRuleFormValidationData
     */
    salesJourneys?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterRuleFormValidationData
     */
    marketingFlightNumbers?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterRuleFormValidationData
     */
    providers?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterRuleFormValidationData
     */
    fareTypes?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterRuleFormValidationData
     */
    carriers?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterRuleFormValidationData
     */
    bookingClasses?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterRuleFormValidationData
     */
    accountCodes?: ValidationMessage;
    /**
     * 
     * @type {FareBasisValidationData}
     * @memberof GlobalFilterRuleFormValidationData
     */
    fareBasis?: FareBasisValidationData;
}

export function GlobalFilterRuleFormValidationDataFromJSON(json: any): GlobalFilterRuleFormValidationData {
    return GlobalFilterRuleFormValidationDataFromJSONTyped(json, false);
}

export function GlobalFilterRuleFormValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterRuleFormValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : ValidationMessageFromJSON(json['description']),
        'effectiveDates': !exists(json, 'effectiveDates') ? undefined : ValidationMessageFromJSON(json['effectiveDates']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : ValidationMessageFromJSON(json['distributionChannels']),
        'agenciesAndGroups': !exists(json, 'agenciesAndGroups') ? undefined : ValidationMessageFromJSON(json['agenciesAndGroups']),
        'routes': !exists(json, 'routes') ? undefined : ValidationMessageFromJSON(json['routes']),
        'salesJourneys': !exists(json, 'salesJourneys') ? undefined : ValidationMessageFromJSON(json['salesJourneys']),
        'marketingFlightNumbers': !exists(json, 'marketingFlightNumbers') ? undefined : ValidationMessageFromJSON(json['marketingFlightNumbers']),
        'providers': !exists(json, 'providers') ? undefined : ValidationMessageFromJSON(json['providers']),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : ValidationMessageFromJSON(json['fareTypes']),
        'carriers': !exists(json, 'carriers') ? undefined : ValidationMessageFromJSON(json['carriers']),
        'bookingClasses': !exists(json, 'bookingClasses') ? undefined : ValidationMessageFromJSON(json['bookingClasses']),
        'accountCodes': !exists(json, 'accountCodes') ? undefined : ValidationMessageFromJSON(json['accountCodes']),
        'fareBasis': !exists(json, 'fareBasis') ? undefined : FareBasisValidationDataFromJSON(json['fareBasis']),
    };
}

export function GlobalFilterRuleFormValidationDataToJSON(value?: GlobalFilterRuleFormValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': ValidationMessageToJSON(value.description),
        'effectiveDates': ValidationMessageToJSON(value.effectiveDates),
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'distributionChannels': ValidationMessageToJSON(value.distributionChannels),
        'agenciesAndGroups': ValidationMessageToJSON(value.agenciesAndGroups),
        'routes': ValidationMessageToJSON(value.routes),
        'salesJourneys': ValidationMessageToJSON(value.salesJourneys),
        'marketingFlightNumbers': ValidationMessageToJSON(value.marketingFlightNumbers),
        'providers': ValidationMessageToJSON(value.providers),
        'fareTypes': ValidationMessageToJSON(value.fareTypes),
        'carriers': ValidationMessageToJSON(value.carriers),
        'bookingClasses': ValidationMessageToJSON(value.bookingClasses),
        'accountCodes': ValidationMessageToJSON(value.accountCodes),
        'fareBasis': FareBasisValidationDataToJSON(value.fareBasis),
    };
}


